var _rect, _rect2, _g, _circle, _mask, _path, _path2, _circle2, _path3, _path4, _circle3, _ellipse, _circle4, _g2, _path5, _circle5, _ellipse2, _circle6, _g3, _rect3, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIntroduction3Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 255,
    viewBox: "0 0 343 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1604_11004)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 255,
    rx: 16,
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1604_11004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 70,
    width: 245,
    height: 223
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 70,
    width: 245,
    height: 222.103,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1604_11004)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1604_11004)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.3457,
    y: 70,
    width: 187.483,
    height: 296.987,
    rx: 34,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3457,
    y: 74,
    width: 179.483,
    height: 288.987,
    rx: 30,
    stroke: "#2B2B2B",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.348,
    y: 70,
    width: 71.4778,
    height: 19.9556,
    rx: 9.97782,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1604_11004)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.885,
    y: 79.9766,
    width: 16.4047,
    height: 3.52158,
    rx: 1.76079,
    fill: "#666666"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.555,
    cy: 171.555,
    r: 60.5547,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-1_1604_11004",
    maskUnits: "userSpaceOnUse",
    x: 157.931,
    y: 105,
    width: 82,
    height: 134,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 157.931,
    y: 105,
    width: 82,
    height: 134
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.84 111.718C230.791 111.245 227.667 111 224.486 111C191.042 111 163.931 138.111 163.931 171.555C163.931 204.998 191.042 232.109 224.486 232.109C227.667 232.109 230.791 231.864 233.84 231.391V111.718Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.84 111.718C230.791 111.245 227.667 111 224.486 111C191.042 111 163.931 138.111 163.931 171.555C163.931 204.998 191.042 232.109 224.486 232.109C227.667 232.109 230.791 231.864 233.84 231.391V111.718Z",
    fill: "#A5A5A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.84 111.718H239.84V106.577L234.76 105.789L233.84 111.718ZM233.84 231.391L234.76 237.32L239.84 236.533V231.391H233.84ZM224.486 117C227.358 117 230.175 117.221 232.921 117.647L234.76 105.789C231.407 105.269 227.976 105 224.486 105V117ZM169.931 171.555C169.931 141.425 194.356 117 224.486 117V105C187.728 105 157.931 134.798 157.931 171.555H169.931ZM224.486 226.109C194.356 226.109 169.931 201.684 169.931 171.555H157.931C157.931 208.312 187.728 238.109 224.486 238.109V226.109ZM232.921 225.462C230.175 225.888 227.358 226.109 224.486 226.109V238.109C227.976 238.109 231.407 237.84 234.76 237.32L232.921 225.462ZM239.84 231.391V111.718H227.84V231.391H239.84Z",
    fill: "#F2F2F2",
    mask: "url(#path-8-outside-1_1604_11004)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.445,
    cy: 171.555,
    r: 60.5547,
    fill: "#3A7EFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.408 180.984V182.496C112.399 184.5 112.399 186.75 111.758 190.143L109.508 189.914C110.123 186.891 110.149 184.641 110.158 182.76H100.736V180.984H112.408ZM99.2246 193.641V191.812H104.445V186.311H106.678V191.812H113.814V193.641H99.2246ZM128.527 179.613V188.982H126.4V185.115H124.959V188.912H122.85V179.895H124.959V183.287H126.4V179.613H128.527ZM114.605 187.418C117.629 186.319 119.132 184.667 119.475 182.496H115.379V180.703H121.76C121.76 184.729 119.835 187.444 115.66 189.088L114.605 187.418ZM117.365 191.408V189.598H128.527V195.592H126.295V191.408H117.365Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.506 179.613V191.408H212.273V187.506H209.32V188.877H201.709V180.65H203.959V183.111H207.105V180.65H209.32V182.285H212.273V179.613H214.506ZM203.853 195.311V190.23H206.121V193.518H214.84V195.311H203.853ZM203.959 187.119H207.105V184.816H203.959V187.119ZM209.32 185.713H212.273V184.096H209.32V185.713ZM230.519 181.617V183.41H217.213V181.617H222.75V179.754H224.965V181.617H230.519ZM216.58 193.957V192.164H222.75V190.327C220.025 190.081 218.373 188.965 218.391 187.207C218.373 185.265 220.474 184.104 223.857 184.113C227.18 184.104 229.315 185.265 229.307 187.207C229.315 188.965 227.645 190.081 224.965 190.318V192.164H231.223V193.957H216.58ZM220.693 187.207C220.684 188.156 221.783 188.587 223.857 188.578C225.888 188.587 227.004 188.156 227.004 187.207C227.004 186.293 225.888 185.862 223.857 185.854C221.783 185.862 220.684 186.293 220.693 187.207ZM238.025 183.217C238.016 186.082 239.238 188.974 241.805 190.213L240.451 192.006C238.737 191.153 237.577 189.571 236.918 187.646C236.215 189.712 234.984 191.408 233.174 192.305L231.785 190.494C234.501 189.246 235.775 186.188 235.775 183.217V180.826H238.025V183.217ZM242.508 195.592V179.596H244.758V185.766H247.113V187.664H244.758V195.592H242.508Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.105,
    cy: 156.07,
    r: 11.1775,
    fill: "#C8DBFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.715,
    cy: 152.94,
    rx: 3.5768,
    ry: 3.5768,
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1604_11004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 144,
    width: 24,
    height: 24
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.105,
    cy: 156.07,
    r: 11.1775,
    fill: "#BDD4FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1604_11004)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.86,
    cy: 165.46,
    rx: 8.04781,
    ry: 8.0478,
    fill: "#2B2B2B"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.873 157.47L221.942 163.919L223.964 165.804L225.908 163.919L224.962 157.485C224.602 157.436 224.234 157.41 223.86 157.41C223.526 157.41 223.196 157.431 222.873 157.47Z",
    fill: "#2D6AF6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.214,
    cy: 156.07,
    r: 11.1775,
    fill: "#BCD3FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.825,
    cy: 152.94,
    rx: 3.5768,
    ry: 3.5768,
    fill: "#6C8FD0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1604_11004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 144,
    width: 23,
    height: 24
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.214,
    cy: 156.07,
    r: 11.1775,
    fill: "#87B1FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1604_11004)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.969,
    cy: 165.46,
    rx: 8.04781,
    ry: 8.0478,
    fill: "#6C8FD0"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 19,
    width: 71,
    height: 40,
    rx: 8,
    fill: "#3A7EFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8359 33.6875V45H29.4766V35.9219H29.4141L26.8203 37.5469V35.4688L29.6172 33.6875H31.8359ZM35.8359 45.1406C35.1016 45.1406 34.5078 44.5547 34.5234 43.8281C34.5078 43.1094 35.1016 42.5234 35.8359 42.5312C36.5312 42.5234 37.1328 43.1094 37.1328 43.8281C37.1328 44.5547 36.5312 45.1406 35.8359 45.1406ZM34.5234 37.875C34.5078 37.1562 35.1016 36.5703 35.8359 36.5781C36.5312 36.5703 37.1328 37.1562 37.1328 37.875C37.1328 38.6016 36.5312 39.1875 35.8359 39.1875C35.1016 39.1875 34.5078 38.6016 34.5234 37.875ZM43.8516 33.6875V45H41.4922V35.9219H41.4297L38.8359 37.5469V35.4688L41.6328 33.6875H43.8516ZM62.0234 32.2188V46.4375H60.1172V39.2656H58.8359V45.7812H56.9453V32.4219H58.8359V37.6406H60.1172V32.2188H62.0234ZM50.1016 42.8594V33.6875H55.7578V42.8594H50.1016ZM51.9609 41.2969H53.8984V35.2656H51.9609V41.2969ZM71.9609 33.7031V35.2812H69.0547C69.1016 36.7344 70.1953 38.1953 72.4766 38.7969L71.5547 40.3281C69.9141 39.9062 68.7578 38.9922 68.0938 37.8125C67.4609 39.125 66.2969 40.1719 64.6016 40.6406L63.6484 39.0938C65.9141 38.4609 66.9922 36.8594 67.0391 35.2812H64.1328V33.7031H67.0391V32.2344H69.0703V33.7031H71.9609ZM65.6953 43.7344C65.6875 42.0312 67.5547 41.0391 70.5859 41.0312C73.5938 41.0391 75.4609 42.0312 75.4766 43.7344C75.4609 45.4531 73.5938 46.4453 70.5859 46.4375C67.5547 46.4453 65.6875 45.4531 65.6953 43.7344ZM67.6953 43.7344C67.6953 44.5234 68.6719 44.9219 70.5859 44.9219C72.4844 44.9219 73.5 44.5234 73.5078 43.7344C73.5 42.9766 72.4844 42.5703 70.5859 42.5781C68.6719 42.5703 67.6953 42.9766 67.6953 43.7344ZM73.4297 40.8125V32.2344H75.4297V40.8125H73.4297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1604_11004",
    x: 73.3457,
    y: 70,
    width: 195.483,
    height: 304.986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1604_11004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1604_11004",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1604_11004",
    x: 162.885,
    y: 79.9766,
    width: 17.4048,
    height: 4.52148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1604_11004"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1604_11004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 255,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIntroduction3Mobile);
export default __webpack_public_path__ + "static/media/ImgIntroduction3Mobile.71a879145fdab7bbf3db3de5c909af51.svg";
export { ForwardRef as ReactComponent };